import HTTP from "./http.service";

var Advertisement = {};
Advertisement.getOTP = (number) => {
    let config = {
        method: "post",
        url: "/fraud/check_customer_with_otp",
        data: number,
    };
    return HTTP(config);
}

Advertisement.verifyOTP = (data) => {
    let config = {
        method: "post",
        url: "/complaints/verify_otp",
        data: data,
    };
    return HTTP(config);
}

Advertisement.updateAdvertisement = (data) => {
    let config = {
        method: "post",
        url: "/customer_preference/consents",
        data: data,
    };
    return HTTP(config);
}

Advertisement.getPreference = (data) => {
    let config = {
        method: "get",
        url: `/customer_preference/consents?number=${data}`,
    };
    return HTTP(config);
}

export default Advertisement;